
import { Options } from "vue-class-component";
import { computed } from "vue";
import Base from "./../base/Base.vue";
import { User } from "../../model/user.model";
@Options({})
export default class RightHall extends Base {
  currentUser: User = {
    uid: "",
    displayName: "",
    email: "",
    phoneNumber: "",
    photoURL: "",
    roles: []
  };
  created() {
    this.currentUser = computed(() => this.store.getters.getCurrentUser).value;
  }
}
